import { MediaBankFileModel } from '@fi-app/media-bank/media-bank-file.model';
import { AfterViewInit } from '@angular/core';
import {
    Component,
    ElementRef,
    Input,
    Output,
    Renderer2,
    ViewChild,
    EventEmitter,
    ViewEncapsulation,
} from '@angular/core';
import { LoadingService } from '@fi-shared/fi-loading/loading.service';
import { ExtendedSearchService } from '../fi-services/extended-search.service';
import { FileUploadModel } from './file-upload.model';
import { FiFileUpload2Service } from '@fi-shared/fi-insert-media/fi-file-upload2.service';
import { FiInsertMedia2Service } from '@fi-shared/fi-insert-media/fi-insert-media2.service';

@Component({
    selector: 'fi-file-upload',
    templateUrl: './file-upload.component.html',
    styleUrls: ['./file-upload.component.scss'],
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-file-upload' },
    standalone: false,
})
export class FileUploadComponent implements AfterViewInit {
    @Input() fileUploadSettings: FileUploadModel;
    @Input() isNewVersion: boolean = false;
    @Input() processDrop: boolean = true;
    @Input() selectedFiles: MediaBankFileModel[] = [];
    @Input() isUploadButtonShown: boolean = true;
    @Input() isDefaultBrowseButton: boolean = true;
    @Input() isDndOverlayShown: boolean = false;
    @Input() showDelete: boolean = false;
    @Input() isMaterialUploadButton: boolean = false;
    @Input() dndOverlayIconsSize: number = 65;
    @Input() isDndOverlayTextShown: boolean = true;
    @Output() deleteFunction = new EventEmitter();
    @ViewChild('inputFile', { static: false }) inputFileElement: ElementRef<HTMLElement>;

    isExtractFilesPrevent = true;

    constructor(
        public elementRef: ElementRef<HTMLElement>,
        private renderer: Renderer2,
        private fiLoadingService: LoadingService,
        private extendedSearchService: ExtendedSearchService,
        private fileUpload2Service: FiFileUpload2Service,
        private fiInsertMedia2Service: FiInsertMedia2Service,
    ) {}

    ngAfterViewInit() {
        if (this.processDrop) {
            this.isExtractFilesPrevent = false;
        }
    }

    getDropFilesTitle() {
        if (this.fileUploadSettings.DropFilesTextId) {
            return this.fileUploadSettings.DropFilesTextId;
        }

        if (this.fileUploadSettings.multiple) {
            return 'ccmFileUpload.dropFilesMultiple';
        } else {
            return 'ccmFileUpload.dropFilesSingle';
        }
    }

    getSelectFilesTitle() {
        if (this.fileUploadSettings.SelectFilesTextId) {
            return this.fileUploadSettings.SelectFilesTextId;
        }
        return 'ccmFileUpload.selectFilesMultiple';
    }

    inputFileChange($event: FileList | Array<Blob>) {
        if ($event.length > 0) {
            this.processFiles($event);
        }
    }

    processFiles(files: FileList | Array<Blob>, fromCamera: boolean = false) {
        /*if (!this.fileUploadSettings.SkipToggleLoadingOnProcessFiles)
            this.fiLoadingService.startLoading();
        setTimeout(() => {
            this.fileUploadSettings.OnFileSelect(files, fromCamera);
            if (!this.fileUploadSettings.SkipToggleLoadingOnProcessFiles)
                this.fiLoadingService.finishLoading();
        }, 0);*/
        this.fileUploadSettings.OnFileSelect(files, fromCamera);
    }

    deleteFile(file) {
        this.deleteFunction.emit(file);
    }

    BrowseMediaBank() {
        this.fiInsertMedia2Service
            .openInsertMediaDialogWithFileSizes(this.fileUploadSettings.objectType, {
                multiple: this.fileUploadSettings.multiple,
                accept: this.fileUploadSettings.accept,
                fileTypes: this.fileUploadSettings.fileTypes,
            })
            .onYesButtonClick((result) => {
                if (this.fileUploadSettings.browseMediaDoneCallback) {
                    this.fileUploadSettings.browseMediaDoneCallback(result.mediaBankFileReferences);
                }
            });
    }
}
